export default {
	// common locales
	"organisation.brand": "Brand",
	"organisation.outlet": "Outlet",
	"organisation.terminal": "Terminal",
	"organisation.supplier": "Supplier",
	"organisation.brands.name": "Brand Name",
	"organisation.brands.address": "Registered Business Address",

	// page titles
	"organisation.brands.page-description": "Each registered company should be created as a brand in uPOS. Business accounting is consolidated at a brand level, thus it is important that you plan your organization structure carefully before on-boarding.",
	"organisation.outlets.page-description": "Create and manage outlets under a brand. Each outlet will have it's own set of daily accounting records.",
	"organisation.terminals.page-description": "Create and manage devices under each outlet.",

	// brand page locales
	"brands.columns.name": "Name",
	"brands.columns.address": "Address",
	"brands.form.id": "ID",
	"brands.form.photo": "Brand Photo",
	"brands.form.name-placeholder": "Business Name",
	"brands.form.name-msg": "Please enter Business Name!",
	"brands.form.address": "Registered Business Address",
	"brands.form.address-msg": "Please enter Business Address!",
	"brands.form.address-placeholder-1": "Address Line 1",
	"brands.form.address-placeholder-2": "Address Line 2",
	"brands.form.company-no": "Company Registration Number",
	"brands.form.gst-no": "GST Registration Number",
	"brands.form.tax": "GST Tax Rate",
	"brands.form.svc-charge": "Service Charge Rate",

	// outlet page locales
	"outlets.columns.name": "Name",
	"outlets.columns.code": "Code",
	"outlets.columns.address": "Address",
	"outlets.columns.opening-time": "Cut-over Time",
	"outlets.form.new-outlet": "Add Outlet",
	"outlets.form.new-outlet-title": "Add New Outlet",
	"outlets.form.edit-outlet-title": "Edit Outlet",
	"outlets.form.id": "ID",
	"outlets.form.code": "Outlet Code",
	"outlets.form.code.required": "Please enter a code for this outlet.",
	"outlets.form.code.max-length": "Code should not be longer than 15 characters.",
	"outlets.form.name": "Outlet Name",
	"outlets.form.name.required": "Please enter a name for this outlet.",
	"outlets.form.brand-msg": "Please select brand",
	"outlets.form.address": "Registered Business Address",
	"outlets.form.address.required": "Please enter Business Address.",
	"outlets.form.address-placeholder-1": "Address Line 1",
	"outlets.form.address-placeholder-2": "Address Line 2",
	"outlets.form.opening-time": "Cut-over Time",
	"outlets.form.opening-time.required": "Please enter Cut-over Time.",
    "outlets.form.opening-time-placeholder": "00:00:00 or Start of new accounting day",
	"outlets.form.opening-balance": "Opening Balance",
	"outlets.form.opening-balance-placeholder": "Default opening balance e.g. 500",
	"outlets.form.exact-amt": "Show 'Exact Amount' shortcut button on tender screen",
	"outlets.form.mall": "Located in this mall",
	"outlets.form.mall.required": "Which mall is this outlet located in?",
	"outlets.form.delete": "Are you sure you want to delete Outlet #{outletId} - {outletName}?",

	// terminal page locales
	"terminals.columns.terminal-id": "Terminal ID",
	"terminals.columns.terminal-no": "Terminal No.",
	"terminals.columns.terminal-type": "Type",
	"terminals.columns.name": "Terminal Name",
	"terminals.columns.description": "Description",
	"terminals.columns.enrolment-date": "Enrolment Date",
	"terminals.columns.enrol-by": "Enroled By",
	"terminals.columns.outlet-id": "Outlet ID",
	"terminals.columns.outlet-code": "Outlet Code",
	"terminals.form.terminal-settings": "Terminal Settings",
	"terminals.form.new-terminal": "Enrol New Terminal",
	"terminals.form.edit-terminal": "Edit Terminal",
	"terminals.form.terminal-id": "Terminal ID",
	"terminals.form.terminal-uuid": "Terminal UUID",
	"terminals.form.outlet-id": "Outlet ID",
	"terminals.form.terminal-no": "Terminal No.",
	"terminals.form.terminal-no.placeholder": "1 to 255",
	"terminals.form.terminal-no.required": "What is the terminal no.?",
	"terminals.form.terminal-no.max-length": "Terminal number cannot be larger than 255.",
	"terminals.form.terminal-type": "Terminal Type",
	"terminals.form.terminal-type.placeholder": "Select a terminal type",
	"terminals.form.terminal-type.required": "What type of Terminal is this?",
	"terminals.form.terminal-name": "Terminal Name",
	"terminals.form.terminal-name.placeholder": "Enter a name for this terminal",
	"terminals.form.terminal-name.required": "What is the name for this terminal?",
	"terminals.form.enrolment-date-msg": "What is the enrolment date?",
	"terminals.form.outlet-id-msg": "What is the outlet ID?",
	"terminals.form.enrol": "Enrol",
	"terminals.form.overwrite": "Overwrite",
	"terminals.form.conflict-title": "Overwrite Terminal No. {terminalNo}?",
	"terminals.form.conflict-description": "There is an existing terminal with this number. Overwriting will revoke all tokens and prevent the existing terminal from communicating with uPOS servers.",
	"terminals.enrol.success-title": "Successfully enrolled Terminal No. {terminalNo} ({terminalName})",
	"terminals.enrol.success-subtitle": "This message will only be shown once. Please save your enrolment token somewhere secure.",
	"terminals.enrol.token": "Enrolment Token",
	"terminals.enrol.token-copy": "Copy Enrolment Token",
	"terminals.enrol.token-copy-alert": "Copied Enrolment Token to clipboard",
	"terminals.delete.warn-title": "Are you sure you want to delete {outletCode} - Terminal No. {terminalNo}?",
	"terminals.delete.warn-subtitle": "Deleting this terminal will revoke all tokens and prevent the existing terminal from communicating with uPOS servers.",

	// supplier page locales
	"suppliers.columns.company-name": "Company Name",
	"suppliers.columns.address": "Address",
	"suppliers.columns.country": "Country",
	"suppliers.columns.postal-code": "Postal Code",
	"suppliers.columns.contact": "Contact",
	"suppliers.columns.email": "Email",

}